import React from 'react';
import { STYLE_FACETS } from '../../constants/tags';

interface StyleFacetSelectProps {
    selectedFacets: string[]; // array of facet IDs
    onChange: (facetIds: string[]) => void;
    label?: string;
    /** Facet names to hide (to avoid duplicates with another tag list) */
    excludeNames?: string[];
}

export const StyleFacetSelect: React.FC<StyleFacetSelectProps> = ({
    selectedFacets,
    onChange,
    label = '风格倾向',
    excludeNames = [],
}) => {
    const handleToggle = (facetId: string) => {
        if (selectedFacets.includes(facetId)) {
            onChange(selectedFacets.filter(id => id !== facetId));
        } else {
            onChange([...selectedFacets, facetId]);
        }
    };

    const excludeSet = new Set(excludeNames.map(n => n.toLowerCase().trim()));
    const visibleFacets = STYLE_FACETS.filter(f => !excludeSet.has(f.name.toLowerCase().trim()));

    return (
        <div className="space-y-2">
            {label && (
                <label className="text-sm font-medium text-slate-700 block">
                    {label}
                    <span className="text-slate-400 font-normal ml-2 text-xs">可选</span>
                </label>
            )}
            <div className="flex flex-wrap gap-2">
                {visibleFacets.map(facet => {
                    const isSelected = selectedFacets.includes(facet.id);
                    return (
                        <button
                            key={facet.id}
                            type="button"
                            onClick={() => handleToggle(facet.id)}
                            className={`
                                px-3 py-1.5 rounded-full text-sm font-medium transition-all border
                                ${isSelected
                                    ? 'bg-blue-600 text-white border-blue-600 shadow-sm'
                                    : 'bg-white text-slate-600 border-slate-200 hover:border-slate-300 hover:bg-slate-50'
                                }
                            `}
                            aria-pressed={isSelected}
                        >
                            {facet.name}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
